import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import { AccountCategory, Module, useGeneratePortfolioTeamMemberSignupLinksCsvMutation, useGetAccountQuery, useGetUserQuery, useListBasicAccountsQuery } from '~/types/types';
import { ADMIN_ACCOUNT_ID, useShowDebugging } from '~/functions/accounts';
export default /*#__PURE__*/_defineComponent({
  __name: 'Nav',
  setup: function setup(__props) {
    var _$auth$$state2, _$auth$$state2$user;
    var enableListView = false;
    var $i18n;
    if (isVue3) {
      $i18n = useI18n();
    } else {
      $i18n = useNuxtApp().$i18n;
    }
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth,
      $sentry = _useNuxtApp.$sentry,
      $vuetify = _useNuxtApp.$vuetify;
    var _useGetAccountQuery = useGetAccountQuery({}, computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      result = _useGetAccountQuery.result;
    var account = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount;
    });
    var ventureLinks = computed(function () {
      var _result$value2;
      return ((_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.getAccount.ventureLinks) || [];
    });
    var hasEsgModule = computed(function () {
      return ventureLinks === null || ventureLinks === void 0 ? void 0 : ventureLinks.value.some(function (v) {
        var _v$modules;
        return (_v$modules = v.modules) === null || _v$modules === void 0 ? void 0 : _v$modules.includes(Module.Esg);
      });
    });
    var accountType = computed(function () {
      var _result$value3;
      return (_result$value3 = result.value) === null || _result$value3 === void 0 ? void 0 : _result$value3.getAccount.type;
    });
    var home = computed(function () {
      var _account$value;
      if (((_account$value = account.value) === null || _account$value === void 0 ? void 0 : _account$value.type) === AccountCategory.Portfolio) {
        return '/portfolio/dashboard';
      } else {
        var _account$value2;
        return "/".concat((_account$value2 = account.value) === null || _account$value2 === void 0 ? void 0 : _account$value2.id, "/modules");
      }
    });
    var _useGetUserQuery = useGetUserQuery(computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      userResult = _useGetUserQuery.result,
      onGetUserResult = _useGetUserQuery.onResult;
    var user = computed(function () {
      var _userResult$value;
      return ((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser) || {
        locale: 'en-US',
        isAdmin: false
      };
    });
    onGetUserResult(function (_ref) {
      var _data$getUser;
      var data = _ref.data;
      $i18n.setLocale(data === null || data === void 0 ? void 0 : (_data$getUser = data.getUser) === null || _data$getUser === void 0 ? void 0 : _data$getUser.locale);
      if ($vuetify !== null && $vuetify !== void 0 && $vuetify.lang) {
        var _data$getUser2;
        $vuetify.lang.current = data === null || data === void 0 ? void 0 : (_data$getUser2 = data.getUser) === null || _data$getUser2 === void 0 ? void 0 : _data$getUser2.locale;
      }
    });
    var realEmail = computed(function () {
      var _$auth$$state, _$auth$$state$user;
      return $auth === null || $auth === void 0 ? void 0 : (_$auth$$state = $auth.$state) === null || _$auth$$state === void 0 ? void 0 : (_$auth$$state$user = _$auth$$state.user) === null || _$auth$$state$user === void 0 ? void 0 : _$auth$$state$user.email;
    }); // NOT impersonated user's email
    $sentry === null || $sentry === void 0 ? void 0 : $sentry.setUser({
      email: $auth === null || $auth === void 0 ? void 0 : (_$auth$$state2 = $auth.$state) === null || _$auth$$state2 === void 0 ? void 0 : (_$auth$$state2$user = _$auth$$state2.user) === null || _$auth$$state2$user === void 0 ? void 0 : _$auth$$state2$user.email
    });
    var search = ref('');
    var isCreateDemoDialogOpen = ref(false);
    var _useListBasicAccounts = useListBasicAccountsQuery({
        limit: -1,
        filters: {
          keyword: search
        }
      }, computed(function () {
        var _user$value;
        return {
          enabled: ((_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.isAdmin) && Boolean(search.value)
        };
      })),
      companyResult = _useListBasicAccounts.result,
      companyLoading = _useListBasicAccounts.loading;
    var companies = computed(function () {
      var _companyResult$value, _companyResult$value$;
      return (_companyResult$value = companyResult.value) === null || _companyResult$value === void 0 ? void 0 : (_companyResult$value$ = _companyResult$value.listAccounts) === null || _companyResult$value$ === void 0 ? void 0 : _companyResult$value$.map(function (item) {
        return {
          id: item.id,
          name: "".concat(item.name),
          type: item.type
        };
      });
    });
    var accountMembershipRoles = computed(function () {
      var _account$value3;
      var roles = ((_account$value3 = account.value) === null || _account$value3 === void 0 ? void 0 : _account$value3.membershipRoles) || [];
      return roles;
    });
    var canInviteTeamMembers = computed(function () {
      var _account$value4, _user$value2;
      if (((_account$value4 = account.value) === null || _account$value4 === void 0 ? void 0 : _account$value4.id) === ADMIN_ACCOUNT_ID) return false;
      return Boolean((_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.isAdmin) || accountMembershipRoles.value.includes('ADMIN');
    });
    var showDebugging = useShowDebugging();
    var isGeneratingBatchTeamLinks = ref(false);
    var _useGeneratePortfolio = useGeneratePortfolioTeamMemberSignupLinksCsvMutation({
        fetchPolicy: 'no-cache'
      }),
      generatePortfolioTeamMemberSignupLinksCsv = _useGeneratePortfolio.mutate,
      onGeneratePortfolioTeamMemberSignupLinksCsvDone = _useGeneratePortfolio.onDone,
      onGeneratePortfolioTeamMemberSignupLinksCsvError = _useGeneratePortfolio.onError;
    onGeneratePortfolioTeamMemberSignupLinksCsvDone(function (_ref2) {
      var _account$value5;
      var data = _ref2.data;
      var csvContent = (data === null || data === void 0 ? void 0 : data.generatePortfolioTeamMemberSignupLinksCsv) || '';
      var blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;'
      });
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      var accountName = (((_account$value5 = account.value) === null || _account$value5 === void 0 ? void 0 : _account$value5.name) || 'portfolio').toString().replace(/[^\w\-]+/g, '_');
      link.href = url;
      link.setAttribute('download', "".concat(accountName, "_team_signup_links.csv"));
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      isGeneratingBatchTeamLinks.value = false;
    });
    onGeneratePortfolioTeamMemberSignupLinksCsvError(function (err) {
      window.$nuxt.$emit('userError', {
        message: (err === null || err === void 0 ? void 0 : err.message) || 'Failed to export team signup links.',
        color: 'red'
      });
      isGeneratingBatchTeamLinks.value = false;
    });
    var downloadBatchTeamMemberLinksCsv = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _account$value6;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if ((_account$value6 = account.value) !== null && _account$value6 !== void 0 && _account$value6.id) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              isGeneratingBatchTeamLinks.value = true;
              generatePortfolioTeamMemberSignupLinksCsv();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function downloadBatchTeamMemberLinksCsv() {
        return _ref3.apply(this, arguments);
      };
    }();
    var impersonatedUser = ref(sessionStorage.getItem('impersonation_user_id'));
    var onUserChange = function onUserChange(value) {
      var _user$value3;
      if (user !== null && user !== void 0 && (_user$value3 = user.value) !== null && _user$value3 !== void 0 && _user$value3.isAdmin) {
        var _selectedAccount$valu;
        sessionStorage.setItem('ix-account-id', (_selectedAccount$valu = selectedAccount.value) === null || _selectedAccount$valu === void 0 ? void 0 : _selectedAccount$valu.id); // also set account id, so when a user has more than 1 accounts access, it will directly load the selected account
        sessionStorage.setItem('impersonation_user_id', value.id);
        impersonatedUser.value = value.id;
        window.location.href = '/';
      }
    };
    var endImpersonation = function endImpersonation() {
      sessionStorage.removeItem('impersonation_user_id');
      impersonatedUser.value = null;
      window.location.href = '/';
    };
    var mini = ref(true);
    function onMiniVariantUpdate(value) {
      mini.value = value;
    }
    try {
      JSON.parse(localStorage.getItem('debugging'));
    } catch (_unused) {
      localStorage.setItem('debugging', JSON.stringify([]));
    }
    var debugging = ref(JSON.parse(localStorage.getItem('debugging')));
    watch(debugging, function () {
      localStorage.setItem('debugging', JSON.stringify(debugging.value));
    });
    var portfolioLink = function portfolioLink() {
      return {
        name: 'portfolio-esgList'
      };
    };
    var selectedAccount = ref({});
    return {
      __sfc: true,
      enableListView: enableListView,
      $i18n: $i18n,
      $auth: $auth,
      $sentry: $sentry,
      $vuetify: $vuetify,
      result: result,
      account: account,
      ventureLinks: ventureLinks,
      hasEsgModule: hasEsgModule,
      accountType: accountType,
      home: home,
      userResult: userResult,
      onGetUserResult: onGetUserResult,
      user: user,
      realEmail: realEmail,
      search: search,
      isCreateDemoDialogOpen: isCreateDemoDialogOpen,
      companyResult: companyResult,
      companyLoading: companyLoading,
      companies: companies,
      accountMembershipRoles: accountMembershipRoles,
      canInviteTeamMembers: canInviteTeamMembers,
      showDebugging: showDebugging,
      isGeneratingBatchTeamLinks: isGeneratingBatchTeamLinks,
      generatePortfolioTeamMemberSignupLinksCsv: generatePortfolioTeamMemberSignupLinksCsv,
      onGeneratePortfolioTeamMemberSignupLinksCsvDone: onGeneratePortfolioTeamMemberSignupLinksCsvDone,
      onGeneratePortfolioTeamMemberSignupLinksCsvError: onGeneratePortfolioTeamMemberSignupLinksCsvError,
      downloadBatchTeamMemberLinksCsv: downloadBatchTeamMemberLinksCsv,
      impersonatedUser: impersonatedUser,
      onUserChange: onUserChange,
      endImpersonation: endImpersonation,
      mini: mini,
      onMiniVariantUpdate: onMiniVariantUpdate,
      debugging: debugging,
      portfolioLink: portfolioLink,
      selectedAccount: selectedAccount,
      AccountCategory: AccountCategory
    };
  }
});